import { createContext } from 'react'

// Height in pixels of the banners stacked at the top of the window
// (impersonation, announcement, new release — #77). The sidebar and the page
// are `position: fixed` / offset from the top, so they start below it.
export const TopBannersContext = createContext(0)
